// extracted by mini-css-extract-plugin
module.exports =  {"cards":"ccfda6eb9f--cards--3s5H4","card":"ccfda6eb9f--card--Nmwza","img":"ccfda6eb9f--img--ByPHc","title":"ccfda6eb9f--title--JHqoW","text":"ccfda6eb9f--text--fqFFV"};